import { toast } from "react-hot-toast";
import { apicall } from "../../services/api";
import {
	GET_SOURCE_BUSINESS,
	GET_SOURCE_BUSINESSES,
	ADD_SOURCE_BUSINESS,
	UPDATE_SOURCE_BUSINESS,
	REMOVE_SOURCE_BUSINESS,
	ERR_SOURCE_BUSINESS,
	LOADING_SOURCE_BUSINESS,
} from "../actions/actionTypes";

export const getAllSourceBusiness = () => async (dispatch) => {
	try {
		const res = await apicall(`source_business/`, "get");
		if (res.data.msg === "No data found.") {
			dispatch({
				type: GET_SOURCE_BUSINESSES,
				payload: res.data.data,
			});
		} else {
			dispatch({
				type: GET_SOURCE_BUSINESSES,
				payload: res.data,
			});
		}
		return res.data;
	} catch (err) {
		dispatch({
			type: ERR_SOURCE_BUSINESS,
			payload: { msg: "error in get all data", status: err.response.status },
		});
	}
};
export const getAllSourceBusinessV3 = ({
  page = 1,
  limit = 10,
  search = '',
  start_date = '',
  end_date = '',
}) => async (dispatch) => {
  try {
    const queryParams = new URLSearchParams({
      page,
      limit,
      ...(search && { search }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date }),
    }).toString();

    const res = await apicall(`source_business?${queryParams}`, "get", null, {}, "v3");
    dispatch({
      type: GET_SOURCE_BUSINESSES,
      payload: res?.data?.data,
    });

    return res.data;
  } catch (err) {
    dispatch({
      type: ERR_SOURCE_BUSINESS,
      payload: {
        msg: "Error fetching source businesses",
        status: err.response?.status || 500,
      },
    });
  }
};


export const getSourceBusiness = (sourceBusinessId) => async (dispatch) => {
	try {
		const res = await apicall(`source_business/${sourceBusinessId}`, "get");
		dispatch({
			type: GET_SOURCE_BUSINESS,
			payload: res.data,
		});
	} catch (err) {
		dispatch({
			type: ERR_SOURCE_BUSINESS,
			payload: { msg: err.response.msg, status: err.response.status },
		});
	}
};

export const createSourceBusiness = (formData) => async (dispatch) => {
	try {
		const res = await apicall("source_business", "post", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				"Access-Control-Allow-Origin": "*",
			},
		});
		dispatch({
			type: ADD_SOURCE_BUSINESS,
			payload: res.data,
		});
		dispatch({
			type: ERR_SOURCE_BUSINESS,
			payload: { msg: res.data.msg, status: res.status },
		});
		dispatch(getAllSourceBusiness());
		dispatch(showLoading(false));
	} catch (err) {
		dispatch({
			type: ERR_SOURCE_BUSINESS,
			payload: { msg: err.response.data.msg, status: err.response.status },
		});
		dispatch(showLoading(false));
	}
};

export const updateSourceBusiness =
	(sourceBusinessId, formData, type) => async (dispatch) => {
		try {
			const isFormData = formData instanceof FormData;
			const headers = isFormData
				? { "Content-Type": "multipart/form-data", "Access-Control-Allow-Origin": "*" }
				: { "Content-Type": "application/json", "Access-Control-Allow-Origin": "*" };

			const path =
				type === "status"
					? `source_business/${sourceBusinessId}/status`
					: type === "verified"
					? `source_business/${sourceBusinessId}/verified`
					: `source_business/${sourceBusinessId}`;

			const res = await apicall(
				path,
				"patch",
				formData,
				{ headers },
				"v3"
			);
			dispatch({
				type: UPDATE_SOURCE_BUSINESS,
				payload: {
					brand_id: sourceBusinessId,
					updatedData: res.data?.data,
				},
			});
			dispatch({
				type: ERR_SOURCE_BUSINESS,
				payload: { msg: "Brand updated successfully", status: 200 },
			});
			dispatch(getAllSourceBusinessV3({ page: 1, limit: 10 }));
			dispatch(showLoading(false));
		} catch (err) {
			dispatch({
				type: ERR_SOURCE_BUSINESS,
				payload: { msg: err.response?.data?.msg || "Error updating brand", status: err.response?.status || 500 },
			});
			dispatch(showLoading(false));
		}
	};

export const deleteSourceBusiness = (sourceBusinessId) => async (dispatch) => {
	try {
		const res = await apicall(
			`source_business/${sourceBusinessId}`,
			"delete"
		);
		dispatch({ type: REMOVE_SOURCE_BUSINESS, payload: sourceBusinessId });
		dispatch({
			type: ERR_SOURCE_BUSINESS,
			payload: { msg: `Brand deleted successfully!`, status: res.status },
		});
		toast.success("Brand deleted successfully!");
	} catch (err) {
		dispatch({
			type: ERR_SOURCE_BUSINESS,
			payload: { msg: err.response.data.msg, status: err.response.status },
		});
		toast.error(err.response.data.msg);
	}
};
export const deleteSourceBusinessV3 = (sourceBusinessId) => async (dispatch) => {
	try {
		const res = await apicall(`source_business/${sourceBusinessId}`, 'delete' , null, {}, 'v3');
		dispatch({ type: REMOVE_SOURCE_BUSINESS, payload: sourceBusinessId });

		dispatch({
			type: ERR_SOURCE_BUSINESS,
			payload: { msg: `Brand deleted successfully!`, status: res.status },
		});
		toast.success("Brand deleted successfully!");
	} catch (err) {
		dispatch({
			type: ERR_SOURCE_BUSINESS,
			payload: { msg: err.response.data.msg, status: err.response.status },
		});
		toast.error(err.response.data.msg);
	}
};

export const setERR_SOURCE_BUSINESS = (error) => async (dispatch) => {
	if (error) {
		dispatch({
			type: ERR_SOURCE_BUSINESS,
			payload: error,
		});
	} else {
		dispatch({
			type: ERR_SOURCE_BUSINESS,
			payload: { msg: "", status: 500 },
		});
	}
}

export const showLoading = (flag) => async (dispatch) => {
	dispatch({
		type: LOADING_SOURCE_BUSINESS,
		payload: flag,
	});
}